module.exports = __webpack_public_path__ + "img/7134980.jpg";